import { RecentDocument } from "v2/store/entityDocumentsApi";
import { groupRecentBySection } from "./groupRecentBySection";
import { ScrollListHint } from "./ScrollListHint";
import { UploadedDocumentRow } from "./UploadedDocumentRow";
import { useScrollListHint } from "./useScrollListHint";

type RecentlyUpdatedByInkleProps = {
  documents: RecentDocument[];
};

export const RecentlyUpdatedByInkle = ({
  documents,
}: RecentlyUpdatedByInkleProps) => {
  const { ref, showHint, onScroll, scrollDown } =
    useScrollListHint<HTMLDivElement>(documents.length);

  if (documents.length === 0) return null;

  const groups = groupRecentBySection(documents);

  return (
    <div className="t-rounded-2xl t-border t-border-solid t-border-neutral-10 t-bg-surface t-px-8 t-pt-8">
      <div className="t-mb-1 t-text-subtitle-lg t-text-text-60">
        Recently uploaded by Inkle
      </div>
      <p className="t-mb-4 t-text-body t-text-neutral-50">
        Recent documents and records uploaded by Inkle within the last 30 days.
      </p>

      <div className="t-relative t-mb-3">
        <div
          ref={ref}
          onScroll={onScroll}
          className="hide-scrollbar t-max-h-[420px] t-overflow-y-auto t-pb-3 t-pr-1.5"
        >
          {groups.map((group) => (
            <div
              key={group.section ?? "unclassified"}
              className="t-mb-3 last:t-mb-0"
            >
              {group.section && (
                <div className="t-mb-1 t-px-2 t-text-body-sm t-text-text-30">
                  {group.section}
                </div>
              )}
              {group.documents.map((document) => (
                <UploadedDocumentRow
                  key={document.id}
                  document={document}
                  readOnly
                />
              ))}
            </div>
          ))}
        </div>

        {showHint && <ScrollListHint onClick={scrollDown} />}
      </div>
    </div>
  );
};
